<div class="pie-chart-container">
  <p-chart type="pie"
           #pieChart
           [data]="data"
           [options]="options"
           (onDataSelect)="onChartDataSelect($event)" />
</div>
